import { Controller, RegisterOptions } from 'react-hook-form';
import { FormHelpText, Stack, TextField } from 'ui-components';

type ControlledTextFieldProps = React.ComponentPropsWithRef<typeof TextField> & {
  name: string;
  label: string;
  onChange?: (value: React.ChangeEvent<HTMLInputElement>) => void;
  loading?: boolean;
  rules?: Omit<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>;
};

export function ControlledTextField({
  name,
  label,
  loading = false,
  rules = {},
  onChange,
  ...props
}: ControlledTextFieldProps): React.ReactElement {
  const completeRules = { required: props.required ? 'Das darf nicht leer sein' : false, ...rules };

  return (
    <Controller
      name={name}
      rules={completeRules}
      render={({ field, fieldState: { invalid, error } }) => (
        <Stack gap={1} className="relative">
          <TextField
            {...field}
            onChange={(value) => {
              field.onChange(value);
              onChange?.(value);
            }}
            {...props}
            loading={loading}
            label={label}
            invalid={invalid}
          />

          {error && <FormHelpText error={invalid}>{error.message}</FormHelpText>}
        </Stack>
      )}
    />
  );
}
